import { getEmail } from './user';
export var isHomeDepotEmail = function (email) {
    var emailName = email || getEmail() || '';
    return emailName.includes('homedepot.com');
};
